export default {"src":"/_next/static/media/heartHeaderIcon.4d2cc052.svg","height":14,"width":17,"blurWidth":0,"blurHeight":0};